import { IStepStatus } from '../../../interface/progress.interface';

interface Props {
  isFull: boolean;
  stepStatus: IStepStatus;
  stepPercent: number | null;
  increaseProgress: Function;
  decreaseProgress: Function
}
const changeStepProgress = ({
  isFull,
  stepStatus,
  stepPercent,
  increaseProgress,
  decreaseProgress
}: Props) => {
  let newStepStatus
  if (isFull) {
    if (stepStatus === IStepStatus.none || stepStatus === IStepStatus.change) {
      increaseProgress(stepPercent)
    }
    newStepStatus = IStepStatus.success
  } else {
    if (stepStatus === IStepStatus.success) {
      decreaseProgress(stepPercent)
    }
    newStepStatus = IStepStatus.change
  }

  return newStepStatus
}

export default changeStepProgress